export default "__VITE_ASSET__DkHIUAUQ__"